/**
 * 德语（de）
 */

import deLocale from 'element-ui/lib/locale/lang/de'
import publish from './publish/de'
import personal from './personal/de'
import order from './order/de'
import customProduct from './customProduct/de'
import index from './index/de'
export default {
  ...deLocale,
  currency: {
    product: 'Produkt',
    inStock: 'Auf Lager',
    myProduct: 'Mein Produkt',
    listings: 'Inserate',
    wishList: 'Wunschliste',
    allOrder: 'Alle Reihenfolge',
    store: 'Speichern',
    personalCenter: 'Persönliches Zentrum',
    payment: 'Zahlung',
    address: 'Adresse',
    accountSettings: 'Kontoeinstellungen',
    logOut: 'Abmelden',
    cancel: 'Abbrechen',
    submit: 'Senden',
    selectAll: 'Alle auswählen',
    confirmOrder: 'Bestellung bestätigen',
    back: 'zurück',
    sortBy: 'Sortieren nach',
    newest: 'Neueste',
    highestInventory: 'Höchster Bestand',
    highestSales: 'Höchste Umsätze',
    highestPrice: 'Höchster Preis',
    lowestPrice: 'Niedrigster Preis',
    customProduct: 'Kundenspezifisches Produkt',
    home: 'Home',
    newIn: 'Neu in',
    deleteTip: 'Sind Sie sicher, das ausgewählte Produkt zu löschen?',
    delete: 'löschen'
  },
  // 语言
  lang: {
    english: 'Englisch',
    chinese: 'Chinesisch',
    spanish: 'Spanisch',
    japanese: 'Japanisch',
    portuguese: 'Portugiesisch',
    french: 'Französisch',
    russian: 'Russisch',
    arabic: 'Arabisch',
    german: 'Deutsch',
    italian: 'Italienisch',
    vietnam: 'Vietnam',
    turkey: 'Türkei',
    korean: 'Koreanisch',
    thai: 'Thai',
    dutch: 'Niederländisch',
    hebrew: 'Hebräisch',
    indonesian: 'Indonesisch'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'Kategorie',
    search: 'Suche',
    searchingFor: 'Trennen Sie mehrere Suchen mit Kommas oder Leerzeichen',
    shippingFrom: 'Versand von',
    fabric: 'Stoff',
    price: 'Preis',
    inventory: 'Inventar',
    newest: 'Neueste',
    sales: 'Der Umsatz',
    min: 'Min',
    max: 'Max.',
    recentSearches: 'Letzte Suchanfragen',
    hotSearches: 'Heiße Suchanfragen'
  },
  // 商品详情页
  productDetail: {
    product: 'Produkt',
    detail: 'Detail',
    itemNo: 'Artikel Nr.',
    processingTime: 'Zeit der Verarbeitung',
    shippingCost: 'Versandkosten',
    paymentMethod: 'Methode der Zahlung',
    sizeGuide: 'Anleitung zur Größe',
    color: 'Farbe',
    size: 'Größe',
    viewAllVariants: 'Alle Varianten anzeigen',
    allVariants: 'Alle Varianten',
    shipFrom: 'Schiff von',
    addToCart: 'In den Warenkorb',
    listToStore: 'Liste speichern',
    addToWishList: 'Zur Wunschliste hinzufügen',
    description: 'Beschreibung',
    return: 'Zurück',
    refundPolicy: 'Die Rückerstattungspolitik',
    shipping: 'Versand',
    image: 'Bild',
    action: 'Aktion',
    // 选项卡/shipping
    packingSize: 'Größe der Verpackung',
    packingWeight: 'Gewicht der Verpackung',
    shippingFrom: 'Versand ab',
    shippingTo: 'Versand nach',
    qty: 'Qty',
    maximum: 'Maximaler Bestand:',
    shippingMethod: 'Versandart',
    estimatedDeliveryTime: 'Geschätzte Lieferzeit',
    sizeChart: 'Größentabelle',
    deliveryTime: 'Lieferzeit',
    outOfStockTips: 'Sorry, nicht vorrätig!',
    pleaseSelected: 'Bitte wählen',
    customerReviews: 'Kundenbewertungen',
    writeAReview: 'Schreiben Sie eine Rezension'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: 'Warenkorb Warenkorb',
    topTip: 'Wählen Sie Produkte im gleichen Lager aus, um eine Bestellung aufzugeben.'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'Adresse des Versands',
    addNewAddress: 'Neue Adresse hinzufügen',
    selectAnotherAddress: 'Wählen Sie eine andere Adresse',
    editTheAddress: 'Adresse bearbeiten',
    remark: 'Bemerkung',
    unitPrice: 'Preis pro Einheit',
    totalPayable: 'Zahlbar insgesamt',
    itemSubtotal: 'Zwischensumme Element',
    subtotal: 'Zwischensumme',
    shippingSubtotal: 'Versandkosten Zwischensumme',
    promotion: 'Beförderung',
    grandTotal: 'Insgesamt insgesamt',
    creditCard: 'KreditkartenName',
    balance: 'Saldo',
    payNow: 'Jetzt bezahlen',
    commonProblem: 'Gemeinsames Problem',
    emailVerification: 'Überprüfung per E-Mail',
    verificationTitle: 'Ein Verifizierungscode wurde an Ihre E-Mail geschickt',
    verification: 'Überprüfung',
    seconds: 'Sekunden',
    laterGetPasswordAgain: 'Später Passwort erneut erhalten',
    sendAgain: 'erneut senden'
  },
  // 账号设置弹窗
  setting: {
    setting: 'Einstellung',
    fullName: 'FullName',
    email: 'Email',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    notVerified: 'Nicht verifiziert',
    change: 'Änderung',
    codeSend: 'Ein Verifizierungscode wurde an Ihre E-Mail geschickt'
  },
  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index
}
